import { PackageProviderIcon } from 'components/shared/ppoints/PackageProviderIcon';
import { PackageProviderName } from 'data/ppoints/constants';
import PackageProviderService from 'services/settings/ppoints/PackageProviderService';

export const ShippingProviderCardSimplifiedIconWithHeader: React.FC<
    ShippingProviderCardSimplifiedIconWithHeaderProps
> = ({ providerName }) => (
    <>
        <PackageProviderIcon provider={providerName} size="small" />
        <div className="min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
            <s-heading>{PackageProviderService.getDisplayName(providerName)}</s-heading>
        </div>
    </>
);

interface ShippingProviderCardSimplifiedIconWithHeaderProps {
    providerName: PackageProviderName;
}
